export default "__VITE_ASSET__DuijQyIZ__"